module.exports = __webpack_public_path__ + "static/media/error-licencia.70104ac2.gif";